import { render } from "./PpcBidSettingInput.vue?vue&type=template&id=7647e824&scoped=true"
import script from "./PpcBidSettingInput.vue?vue&type=script&lang=js"
export * from "./PpcBidSettingInput.vue?vue&type=script&lang=js"

import "./PpcBidSettingInput.vue?vue&type=style&index=0&id=7647e824&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7647e824"]])

export default __exports__